import { NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { environment } from '../../_environments/environment';
import { CustomerService } from '../../_service/CustomerService';
import { collapse } from '../../_theme/animations';
import { MyValidators } from '../../_validators/MyValidators';
import { ToastService } from 'src/_service/Toast.service';
import { Snackbarformat } from 'src/_theme/snackbarformats';
import { FreshdeskTicketPriority, FreshdeskTicketStatus } from 'src/_model/customer';


//const DEFAULT_DURATION = 150;

@Component({
    selector: 'contactform',
    templateUrl: './contactform.component.html',
    styleUrls: ['./contactform.component.scss'],
    animations: [collapse],
    imports: [ReactiveFormsModule, TranslateModule]
})
export class ContactformComponent implements OnInit, OnDestroy {

  environment = environment;

  contactform = new FormGroup({
    email: new FormControl(null, Validators.required, this._myValidators.Email),
    name: new FormControl(null, Validators.required),
    subject: new FormControl(null, Validators.required),
    description: new FormControl(null, Validators.required),
    priority: new FormControl(FreshdeskTicketPriority.LOW),
    status: new FormControl(FreshdeskTicketStatus.PENDING),
  });

  categories = [
    "DELIVERY",
    "NEW_CUSTOMER",
    "RECIPE",
    "CALLME",
    "COMPLAINT",
    "PRODUCT_DELIVERY_ERROR",
    "BOX_DELIVERY_ERROR"

  ]

  private unsubscribe = new Subject<void>();

  constructor(
    private _customerService: CustomerService,
    private _myValidators: MyValidators,
    private _toastService: ToastService,
    public fb: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    this._customerService.customerSubject.subscribe(res => {
      if (res) {
        this.contactform.get('email').setValue(res.email);
        this.contactform.get('name').setValue((res.firstname ? res.firstname : "") + (res.prefix ? " " + res.prefix : "") + (res.lastname ? " " + res.lastname : ""))
      }
    })
  }

  ngOnDestroy() {
    this.unsubscribe.next();
  }

  hasError = (controlName: string, errorName: string) => {
    if (this.contactform.get(controlName).touched)
      return this.contactform.get(controlName).hasError(errorName);
  }

  sendContactform() {

    this._customerService.createTicket(this.contactform.getRawValue()).subscribe(res => {
      this._toastService.openWithTranslate('contactform.message_send', null, Snackbarformat);
      this.contactform.reset();
    }, error=>{
      this._toastService.openWithTranslate('contactform.error', null, Snackbarformat);
    })
    this.contactform.reset();
  }



}
